import { render, staticRenderFns } from "./VerifyTrade.vue?vue&type=template&id=bb85ce16&scoped=true&"
import script from "./VerifyTrade.vue?vue&type=script&lang=js&"
export * from "./VerifyTrade.vue?vue&type=script&lang=js&"
import style0 from "./VerifyTrade.vue?vue&type=style&index=0&lang=css&"
import style1 from "./VerifyTrade.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./VerifyTrade.vue?vue&type=style&index=2&id=bb85ce16&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb85ce16",
  null
  
)

export default component.exports